<div class="stripe-add-bank-account">
  @if (errorMessage()) {
    <div class="alert alert-danger" role="alert">
      <fa-duotone-icon icon="triangle-exclamation" class="me-2"></fa-duotone-icon>
      {{ errorMessage() }}
    </div>
  }

  <form [formGroup]="bankAccountForm" (ngSubmit)="onSubmit()">
      <div class="mb-3">
        <ms-input-label labelText="Account Holder Name" [isRequired]="true" />
        <input type="text" class="form-control" formControlName="accountHolderName"
          [class.is-invalid]="bankAccountForm.get('accountHolderName')?.touched && bankAccountForm.get('accountHolderName')?.invalid" />
        @if (bankAccountForm.get('accountHolderName')?.invalid && bankAccountForm.get('accountHolderName')?.touched) {
          <div class="error-messages">
            @if (bankAccountForm.get('accountHolderName')?.errors?.['required']) {
              <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.AccountHolderNameRequired }}</p>
            }
            @if (bankAccountForm.get('accountHolderName')?.errors?.['minlength']) {
              <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.AccountHolderNameMinLength }}</p>
            }
          </div>
        }
      </div>

      <div class="mb-3">
        <ms-input-label labelText="Email" />
        <input type="email" class="form-control" formControlName="email"
          [class.is-invalid]="bankAccountForm.get('email')?.touched && bankAccountForm.get('email')?.invalid" />
        @if (bankAccountForm.get('email')?.invalid && bankAccountForm.get('email')?.touched) {
          <div class="error-messages">
            @if (bankAccountForm.get('email')?.errors?.['email']) {
              <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.EmailInvalid }}</p>
            }
          </div>
        }
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <ms-input-label labelText="Routing Number" [isRequired]="true" />
          <input type="text" class="form-control" formControlName="routingNumber" maxlength="9" inputmode="numeric"
            [class.is-invalid]="bankAccountForm.get('routingNumber')?.touched && bankAccountForm.get('routingNumber')?.invalid" />
          @if (bankAccountForm.get('routingNumber')?.invalid && bankAccountForm.get('routingNumber')?.touched) {
            <div class="error-messages">
              @if (bankAccountForm.get('routingNumber')?.errors?.['required']) {
                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.RoutingNumberRequired }}</p>
              }
              @if (bankAccountForm.get('routingNumber')?.errors?.['pattern']) {
                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.RoutingNumberPattern }}</p>
              }
            </div>
          }
        </div>
        <div class="col-md-6">
          <ms-input-label labelText="Account Number" [isRequired]="true" />
          <input type="text" class="form-control" formControlName="accountNumber" maxlength="17" inputmode="numeric"
            [class.is-invalid]="bankAccountForm.get('accountNumber')?.touched && bankAccountForm.get('accountNumber')?.invalid" />
          @if (bankAccountForm.get('accountNumber')?.invalid && bankAccountForm.get('accountNumber')?.touched) {
            <div class="error-messages">
              @if (bankAccountForm.get('accountNumber')?.errors?.['required']) {
                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.AccountNumberRequired }}</p>
              }
              @if (!bankAccountForm.get('accountNumber')?.errors?.['required'] && bankAccountForm.get('accountNumber')?.errors?.['pattern']) {
                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.AccountNumberPattern }}</p>
              }
              @if (!bankAccountForm.get('accountNumber')?.errors?.['required'] && !bankAccountForm.get('accountNumber')?.errors?.['pattern'] && bankAccountForm.get('accountNumber')?.errors?.['minlength']) {
                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.AccountNumberMinLength }}</p>
              }
            </div>
          }
        </div>
      </div>

      <div class="mb-3">
        <ms-input-label labelText="Account Type" [isRequired]="true" />
        <select class="form-select" formControlName="accountHolderType">
          <option value="individual">Individual</option>
          <option value="company">Company</option>
        </select>
      </div>

      <div class="alert alert-warning mb-3" role="alert">
        <fa-duotone-icon icon="triangle-exclamation" class="me-2"></fa-duotone-icon>
        {{ StripeMessagingConstants.STRIPE_BANK_ACCOUNT_MICRODEPOSIT_WARNING() }}
      </div>

      <div class="d-flex justify-content-end gap-2 mt-3">
        <button type="button" class="btn btn-outline-secondary" (click)="onCancel()" [disabled]="isSubmitting()">
          Cancel
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="isSubmitting()">
          @if (isSubmitting()) {
            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
            Saving...
          } @else {
            Add Bank Account
          }
        </button>
      </div>
    </form>
</div>
